// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://optimistic.etherscan.io/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://optimistic.etherscan.io/address/0xD3cF979e676265e4f6379749DECe4708B9A22476
export const PROXY_ADMIN = '0xD3cF979e676265e4f6379749DECe4708B9A22476';

// https://optimistic.etherscan.io/address/0x3b56998Ec06477704622ca8e2eA1b4db134cec32
export const CREATE_3_FACTORY = '0x3b56998Ec06477704622ca8e2eA1b4db134cec32';

// https://optimistic.etherscan.io/address/0x55Cf9583D7D30DC4936bAee1f747591dBECe5df7
export const AAVE_CL_ROBOT_OPERATOR = '0x55Cf9583D7D30DC4936bAee1f747591dBECe5df7';

// https://optimistic.etherscan.io/address/0x56C1a4b54921DEA9A344967a8693C7E661D72968
export const PROTOCOL_GUARDIAN = '0x56C1a4b54921DEA9A344967a8693C7E661D72968';

// https://optimistic.etherscan.io/address/0x1685D81212580DD4cDA287616C2f6F4794927e18
export const AAVE_MERKLE_DISTRIBUTOR = '0x1685D81212580DD4cDA287616C2f6F4794927e18';

// https://optimistic.etherscan.io/address/0xe59EBa0D492cA53C6f46015EEa00517F2707dc77
export const wstETH_stETH_AGGREGATOR = '0xe59EBa0D492cA53C6f46015EEa00517F2707dc77';

// https://optimistic.etherscan.io/address/0x22F3727be377781d1579B7C9222382b21c9d1a8f
export const rETH_ETH_AGGREGATOR = '0x22F3727be377781d1579B7C9222382b21c9d1a8f';

// https://optimistic.etherscan.io/address/0x7d9103572bE58FfE99dc390E8246f02dcAe6f611
export const LEGACY_BRIDGE_EXECUTOR = '0x7d9103572bE58FfE99dc390E8246f02dcAe6f611';

// https://optimistic.etherscan.io/address/0xc3250A20F8a7BbDd23adE87737EE46A45Fe5543E
export const AAVE_OPT_ETH_BRIDGE = '0xc3250A20F8a7BbDd23adE87737EE46A45Fe5543E';

// https://optimistic.etherscan.io/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://optimistic.etherscan.io/address/0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b
export const ALC_SAFE = '0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b';

// https://optimistic.etherscan.io/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://optimistic.etherscan.io/address/0xdeadD8aB03075b7FBA81864202a2f59EE25B312b
export const MERIT_AHAB_SAFE = '0xdeadD8aB03075b7FBA81864202a2f59EE25B312b';

// https://optimistic.etherscan.io/address/0xAA43203167317DeeF8288095C44b84a686918d2E
export const APE_SAFE = '0xAA43203167317DeeF8288095C44b84a686918d2E';

// https://optimistic.etherscan.io/address/0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6
export const APE_VOTING_SAFE = '0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6';

// https://optimistic.etherscan.io/address/0xAA870e4B82deaDa3727235f34183Ec9B728714C8
export const MERIT_INCENTIVE_SAFE = '0xAA870e4B82deaDa3727235f34183Ec9B728714C8';

// https://optimistic.etherscan.io/address/0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e
export const AHAB_SAFE = '0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e';

// https://optimistic.etherscan.io/address/0xfD2aaE32247E5015AcB04Aa8220616D6647979aC
export const REWARD_STEWARD = '0xfD2aaE32247E5015AcB04Aa8220616D6647979aC';

// https://optimistic.etherscan.io/address/0x1aCEC7abbcFE6dD10EA4bB50894908406FfE8719
export const AGENT_HUB = '0x1aCEC7abbcFE6dD10EA4bB50894908406FfE8719';

// https://optimistic.etherscan.io/address/0xEed80d79ae1383884b93d96bd1521F7247EC7e53
export const AGENT_HUB_AUTOMATION = '0xEed80d79ae1383884b93d96bd1521F7247EC7e53';

// https://optimistic.etherscan.io/address/0x9240a6669CC4782FC98620212862DF5CB2e0Df10
export const RANGE_VALIDATION_MODULE = '0x9240a6669CC4782FC98620212862DF5CB2e0Df10';

export const CHAIN_ID = 10;
